import React from 'react';
import PropTypes from 'prop-types';
import { dateDifferenceInDays, isEndOfTime } from '../../utilities/dateFunctions';
import { getDisplayDate } from '../../utilities/displayFunctions';

const DateRange = ({ startDate, endDate }) => {
  return (
    <span>
      {`${getDisplayDate(startDate)} - ${getDisplayDate(endDate)} `}
      {!isEndOfTime(endDate) && <i>{`(${dateDifferenceInDays(startDate, endDate) + 1} days)`}</i>}
    </span>
  );
};

DateRange.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string
};
DateRange.defaultProps = {};

export default DateRange;
